// extracted by mini-css-extract-plugin
export default {"layout":"proClientsLayout_layout__vD96b","clientHeaderTitle":"proClientsLayout_clientHeaderTitle__Yvw2M"};